export default __webpack_public_path__ + "2773dff68016221e8c1b96e440542717.png";